export const orderTypeJa = {
  delivery: 'デリバリー',
  catering: 'ケータリング',
}
 export const mealTypeJa = {
   finger: 'フィンガー',
   buffet: 'ビュッフェ',
   subdivision: '小分け盛り',
 }
